"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedsunnysm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedsunnysm` : '') + (description ? ` desc-brandedsunnysm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedsunnysm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedsunnysm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "m19.71 10.53-3.2 1.83a.57.57 0 0 0-.28.64l.99 3.57a.57.57 0 0 1-.7.7l-3.56-.98a.57.57 0 0 0-.65.27l-1.81 3.22a.57.57 0 0 1-1 0l-1.8-3.22a.57.57 0 0 0-.65-.27l-3.55.99a.57.57 0 0 1-.7-.7L3.76 13a.57.57 0 0 0-.27-.64l-3.2-1.83a.57.57 0 0 1 0-1l3.2-1.82c.23-.12.34-.4.28-.64L2.78 3.5a.57.57 0 0 1 .7-.7l3.56.98c.25.07.52-.04.65-.27L9.5.3a.57.57 0 0 1 1 0l1.81 3.22c.13.23.4.34.65.27l3.55-.99c.43-.11.82.28.7.7l-.98 3.58c-.07.25.04.52.27.64l3.21 1.83c.39.22.39.77 0 1Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 16.67a6.63 6.63 0 0 0 6.62-6.64A6.63 6.63 0 1 0 10 16.67Z",
    fill: "#FFDC9C"
  }));
};
var _default = exports.default = brandedsunnysm;